module.exports = __webpack_public_path__ + "img/brlxgj.7c8700f4.png";